import {useRefinementList, type UseRefinementListProps} from "react-instantsearch";
import {useConfigContext} from "@/ConfigProvider";

import {Panel} from "@/instantsearch/components/Panel";

type FilterRefinementListProps = UseRefinementListProps & {
    title: string;
    multiple_choices: number;
    searchEnabled?: boolean;
}

export function RefinementList(props: FilterRefinementListProps) {
    const {
        items,
        refine,
        canToggleShowMore,
        isShowingMore,
        toggleShowMore,
        searchForItems,
    } = useRefinementList({
        attribute: props.attribute,
        limit: props.limit,
        showMoreLimit: props.showMoreLimit,
        showMore: props.showMore,
        operator: (props.multiple_choices == 1 ? 'or' : 'and'),
        sortBy: ['name:asc'],

    });
    const {tc} = useConfigContext();
    if (items.length === 0) {
        return null;
    }
    return (
        <Panel title={props.title}>
            <div className={"algoliaRefinementList"}>
                {
                    props.searchEnabled &&
                    <div className="inputGroup searchBar"><input type="search"
                                                                 autoCorrect="off"
                                                                 autoCapitalize="off"
                                                                 spellCheck={false}
                                                                 placeholder={`${props.title} durchsuchen …`}
                                                                 onChange={(event) => searchForItems(event.currentTarget.value)}
                                                                 autoComplete="off"/><span
                        className="inputGroup__addon"><i className="icon icon-search" aria-hidden={true}></i></span>
                    </div>
                }

                <ul className="algoliaRefinementList__list">
                    {items.map((item) => {
                        return (
                            <li key={item.label} className={"algoliaRefinementList__item"}>
                                <label htmlFor={item.label}
                                       className={`algoliaRefinementList__label specialcheckbox ${item.isRefined ? "is-active" : ""}`}>
                                    <input
                                        className="algoliaRefinementList__checkbox"
                                        id={item.label}
                                        type="checkbox"
                                        checked={item.isRefined}
                                        onChange={() => refine(item.value)}
                                    />
                                    <i></i>
                                    <span>{item.label}</span>
                                </label>
                            </li>
                        )
                    })}
                    {items.length === 0 && <li>{tc.noEntriesFound}</li>}
                </ul>

                {canToggleShowMore && (
                    <button type="button" onClick={toggleShowMore} className="buttonLink algoliaRefinementList__showMoreButton">
                        {isShowingMore ?
                            <>
                                <i className="icon icon-minus" aria-hidden={true}></i><span>{tc.showLess}</span>
                            </>
                            :
                            <>
                                <i className="icon icon-plus" aria-hidden={true}></i><span>{tc.showMore}</span>
                            </>
                        }
                    </button>
                )}
            </div>
        </Panel>
    );
}